// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-table-expand[data-v-c937fade]{font-size:0}.demo-table-expand label[data-v-c937fade]{width:90px;color:#99a9bf}.demo-table-expand .el-form-item[data-v-c937fade]{margin-right:0;margin-bottom:0;width:50%}.operation[data-v-c937fade]{display:inline-block;margin-right:10px}", ""]);
// Exports
module.exports = exports;
